module.exports = __webpack_public_path__ + "img/confetti_3e.393d149b.svg";